import GiveLlamaButton from './GiveLlamaButton';
import GiveLlamaButtonContainer from './GiveLlamaButton.container';

export default GiveLlamaButtonContainer(GiveLlamaButton);
